import { SortParams } from 'types/common/sorting';
import { FleetServiceData } from 'types/GameHosting/fleet';
import { ChangeAction, DataAction, ErrorAction, FetchAction, PendingAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT = 'FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT';

export const FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING = 'FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING';

export const FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR = 'FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR';

export const FETCH_FLEET = 'FETCH_FLEET';

export const FETCH_FLEET_IS_PENDING = 'FETCH_FLEET_IS_PENDING';

export const FETCH_FLEET_IS_ERROR = 'FETCH_FLEET_IS_ERROR';

export const FETCH_FLEET_BY_ID = 'FETCH_FLEET_BY_ID';

export const FETCH_FLEET_BY_ID_IS_PENDING = 'FETCH_FLEET_BY_ID_IS_PENDING';

export const FETCH_FLEET_BY_ID_IS_ERROR = 'FETCH_FLEET_BY_ID_IS_ERROR';

export const ADD_FLEET = 'ADD_FLEET';

export const ADD_FLEET_IS_PENDING = 'ADD_FLEET_IS_PENDING';

export const ADD_FLEET_IS_ERROR = 'ADD_FLEET_IS_ERROR';

export const UPDATE_FLEET = 'UPDATE_FLEET';

export const UPDATE_FLEET_IS_PENDING = 'UPDATE_FLEET_IS_PENDING';

export const UPDATE_FLEET_IS_ERROR = 'UPDATE_FLEET_IS_ERROR';

export const REMOVE_FLEET = 'REMOVE_FLEET';

export const REMOVE_FLEET_IS_PENDING = 'REMOVE_FLEET_IS_PENDING';

export const REMOVE_FLEET_IS_ERROR = 'REMOVE_FLEET_IS_ERROR';

export const UPDATE_OPERATIONAL_STATUS = 'UPDATE_OPERATIONAL_STATUS';

export const UPDATE_OPERATIONAL_STATUS_IS_PENDING = 'UPDATE_OPERATIONAL_STATUS_IS_PENDING';

export const UPDATE_OPERATIONAL_STATUS_IS_ERROR = 'UPDATE_OPERATIONAL_STATUS_IS_ERROR';

export const RESERVE_HOST_BULK = 'RESERVE_HOST_BULK';

export const RESERVE_HOST_BULK_IS_PENDING = 'RESERVE_HOST_BULK_IS_PENDING';

export const RESERVE_HOST_BULK_IS_ERROR = 'RESERVE_HOST_BULK_IS_ERROR';

export const RESERVE_HOST = 'RESERVE_HOST';

export const RESERVE_HOST_IS_PENDING = 'RESERVE_HOST_IS_PENDING';

export const RESERVE_HOST_IS_ERROR = 'RESERVE_HOST_IS_ERROR';

export const UNRESERVE_HOST = 'UNRESERVE_HOST';

export const UNRESERVE_HOST_IS_PENDING = 'UNRESERVE_HOST_IS_PENDING';

export const UNRESERVE_HOST_IS_ERROR = 'UNRESERVE_HOST_IS_ERROR';

export const SORT = 'SORT_FLEETS';

export type FleetState = FetchReducer<
  'fetchFleets' | 'addFleet' | 'updateFleet' | 'fetchFleetBy' | 'fetchByDepEnv' | 'remove' | 'reserveHostBulk' | 'reserveHost' | 'unreserveHost'
> & {
  isCompleted: boolean;
  isPending: boolean;
  isError: null | unknown;
  fleets: FleetServiceData[];
  fleet: FleetServiceData | {};
} & SortState<FleetServiceData>;

type AddFleetAction =
  | (DataAction<'ADD_FLEET', FleetServiceData> & { originalDepEnvId: string })
  | ErrorAction<`ADD_FLEET_IS_ERROR`>
  | PendingAction<`ADD_FLEET_IS_PENDING`>;

type UpdateFleetAction =
  | (DataAction<'UPDATE_FLEET', FleetServiceData> & { originalDepEnvId: string })
  | ErrorAction<`UPDATE_FLEET_IS_ERROR`>
  | PendingAction<`UPDATE_FLEET_IS_PENDING`>;

type CleanAction = { type: 'CLEAN_ERROR'; errorIndex: number; reducerProperty: keyof FleetState };
type SortAction = { type: 'SORT_FLEETS'; params: SortParams<FleetServiceData> };
type ActionPendingAction = { type: 'ACTION_PENDING'; isPending: boolean };

export type FleetActions =
  | FetchAction<'FETCH_FLEET', FleetServiceData[]>
  | FetchAction<'FETCH_FLEET_BY_ID', FleetServiceData>
  | FetchAction<'FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT', FleetServiceData[]>
  | ChangeAction<'RESERVE_HOST_BULK'>
  | ChangeAction<'RESERVE_HOST'>
  | ChangeAction<'UNRESERVE_HOST'>
  | AddFleetAction
  | UpdateFleetAction
  | FetchAction<'REMOVE_FLEET', FleetServiceData>
  | { type: 'RESET_FLEET_REDUCER'; reason: 'update' | undefined }
  | CleanAction
  | SortAction
  | ActionPendingAction
  | ResetReducerAction;
